export default __webpack_public_path__ + "static/media/inducortes-gray.78675150.webp";